import { render, staticRenderFns } from "./ProductBuy.vue?vue&type=template&id=c817a08e&"
import script from "./ProductBuy.vue?vue&type=script&lang=js&"
export * from "./ProductBuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports